export default __webpack_public_path__ + "static/media/headerBg.26c6b5c2.jpg";